<ul class="pagination" *ngIf="getTotalPages() > 1">
  <li class="page-item">
    <button type="button" class="page-link" [disabled]="currentPage === 1" (click)="onPageChange(1)" aria-label="First page">
      <mat-icon>first_page</mat-icon>
    </button>
  </li>
  <li class="page-item">
    <button type="button" class="page-link" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)" aria-label="Previous page">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </li>

  <ng-container *ngFor="let page of getPageNumbers()">
    <li class="page-item" *ngIf="hidePagesLeftIcon(page)">
      <span class="ellipsis">...</span>
    </li>
    <li class="page-item" [class.active]="page === currentPage">
      <button type="button" class="page-link page-number"
              [class.current]="page === currentPage"
              (click)="onPageChange(page)">{{ page }}</button>
    </li>
    <li class="page-item" *ngIf="hidePagesRightIcon(page)">
      <span class="ellipsis">...</span>
    </li>
  </ng-container>

  <li class="page-item">
    <button type="button" class="page-link" [disabled]="currentPage === getTotalPages()" (click)="onPageChange(currentPage + 1)" aria-label="Next page">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </li>
  <li class="page-item">
    <button type="button" class="page-link" [disabled]="currentPage === getTotalPages()" (click)="onPageChange(getTotalPages())" aria-label="Last page">
      <mat-icon>last_page</mat-icon>
    </button>
  </li>
</ul>
